module.exports = "<div class=\"masthead\">\n    <nav class=\"nav pull-right masthead-right\">\n        <a class=\"nav-link\" href=\"#\"><i class=\"fa fa-search\"></i></a>\n        <a class=\"nav-link\" href=\"#\"><i class=\"fa fa-bell\"></i></a>\n        <a class=\"nav-link\" href=\"#\"><i class=\"fa fa-user\"></i> {{ (user$ | async)?.username }}</a>\n    </nav>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/celine/components/header/header.component.html
// module id = ./src/app/celine/components/header/header.component.html
// module chunks = 0